import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { MaterialModal, ElevatedButton } from 'components/layout'
import styles from './dialog.styl'

const translationShape = PropTypes.shape({
  intlKey: PropTypes.string,
  defaultMessage: PropTypes.string
})

export default class Dialog extends Component {
  static propTypes = {
    modalId: PropTypes.string,
    text: translationShape,
    confirmButton: translationShape,
    cancelButton: translationShape
  }

  static defaultProps = {
    text: {
      intlKey: 'moduleTitle.are_you_sure',
      defaultMessage: 'Are you sure?'
    },
    cancelButton: { intlKey: 'button.cancel', defaultMessage: 'Cancel' },
    confirmButton: { intlKey: 'button.confirm', defaultMessage: 'Confirm' }
  }

  render() {
    const { cancelButton, confirmButton, modalId, text } = this.props

    return (
      <MaterialModal.Body id={modalId} noHeader>
        <MaterialModal.Content minimal>
          <p className={styles.text}>
            <FormattedMessage
              id={text.intlKey}
              defaultMessage={text.defaultMessage}
            />
          </p>
        </MaterialModal.Content>

        <div className={styles.buttons}>
          <ElevatedButton
            onClick={cancelButton.onClick}
            uppercase
            warning
            inline
            padded
          >
            <FormattedMessage
              id={cancelButton.intlKey}
              defaultMessage={cancelButton.defaultMessage}
            />
          </ElevatedButton>
          <ElevatedButton
            onClick={confirmButton.onClick}
            uppercase
            inline
            padded
          >
            <FormattedMessage
              id={confirmButton.intlKey}
              defaultMessage={confirmButton.defaultMessage}
            />
          </ElevatedButton>
        </div>
      </MaterialModal.Body>
    )
  }
}
